import {
  formatPageCount,
  type NoteContentStat,
} from '@bangle.io/service-core';
import type { WsFilePath } from '@bangle.io/ws-path';

/**
 * Sum word counts for notes under a folder (or a single note when
 * `directoryPath` is omitted and `noteWsPath` is given).
 */
export function wordsForTreeEntry({
  kind,
  relativePath,
  noteWsPath,
  notePaths,
  contentStats,
}: {
  kind: 'directory' | 'file';
  relativePath: string;
  noteWsPath?: string;
  notePaths: readonly WsFilePath[];
  contentStats: ReadonlyMap<string, NoteContentStat>;
}): number | undefined {
  if (kind === 'file') {
    if (!noteWsPath) {
      return undefined;
    }
    return contentStats.get(noteWsPath)?.words;
  }

  const prefix = relativePath.endsWith('/')
    ? relativePath
    : `${relativePath}/`;
  let words = 0;
  let matched = false;
  for (const note of notePaths) {
    if (note.path === relativePath || note.path.startsWith(prefix)) {
      matched = true;
      words += contentStats.get(note.wsPath)?.words ?? 0;
    }
  }
  return matched ? words : 0;
}

/** One-line label for the context-menu stats row. */
export function formatTreeEntryStatsLabel(
  words: number,
  wordsPerPage: number,
): string {
  return t.app.components.appSidebar.entryStats({
    words: words.toLocaleString(),
    pages: formatPageCount(words, wordsPerPage),
  });
}
